export const TYPOGRAPHY_CLASSES = [
  'display-4', 'display-3', 'display-2', 'display-1',
  'headline', 'title', 'subheading',
  'body-2', 'body-1', 'caption', 'overline'
]

export const FONT_WEIGHT_CLASSES = [
  'font-weight-thin', 'font-weight-light', 'font-weight-regular',
  'font-weight-medium', 'font-weight-bold', 'font-weight-black'
]

export const VUETIFY_COLORS = [
  'primary', 'secondary', 'accent', 'error', 'warning', 'info', 'success',
  'red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue',
  'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber',
  'orange', 'deep-orange', 'brown', 'blue-grey', 'grey', 'black', 'white'
]



// WEBPACK FOOTER //
// ./src/config/vuetifyTypes.js